// Func = limiting Scope for this file
var lastScrollTop = 0;

window.onload = function() {
	/*this function add a class to header when scroll down the page
	/* and change the logo by a new file if needed depending of mockup
	*/

	// scrollDownAction(20, 'scroll');

	scrollW();
	window.addEventListener('scroll', function(){
		scrollW();
	})

	function scrollW(){
		//check scroll down or up for header styles
		let st = window.pageYOffset || document.documentElement.scrollTop;
		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	
	
	}
};



(function(){

	$(document).ready(function () {

		const window_height = window.innerHeight;
		let animatedEl = document.getElementsByClassName('animate-fade-2');
		for (let i = 0; i < animatedEl.length; i++) {
			var viewportOffset = animatedEl[i].getBoundingClientRect();
			let topPos = viewportOffset.top;
			if(topPos <= window_height*0.8){
				animatedEl[i].classList.add('fade-in');
			}
		}


		$(this, '.booking-content .promo').each(function(){
			$(this).find('.promo-trigger').click(bookingOpen);

		});

		function bookingOpen(){
			$(this).parent(1).find('.flyout-wrapper').css('display','block');
			$(this).parent(1).find('.flyout-wrapper').removeClass("close");
			$(this).parent(1).find('.flyout-wrapper').addClass("opened");
			$(this).unbind('click');
			$(this).click(hideBoking);
		}
		function hideBoking(){
			$(this).parent(1).find('.flyout-wrapper').css('display','none');
			$(this).parent(1).find('.flyout-wrapper').removeClass("opened");
			$(this).parent(1).find('.flyout-wrapper').addClass("close");
			
			
			$(this).unbind('click');
			$(this).click(bookingOpen);
		}
	

		
		$('.sym-slides').slick();

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });
		$('ul.submenu',this).addClass("close");
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
		//	$('ul.submenu',this).addClass("c");
			$('ul.submenu',this).removeClass("close");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).addClass("close");
			$('ul.submenu',this).fadeOut(200);
		});
		$('.js-open-booking').on('click', function(e){		
			$(".booking-widget-inline-date, .booking-widget-inline-date .form-entry.notice, .booking-widget-inline-date .close").animate({ top: "0px"} , 500);
			$("#pickup").trigger("click");
			
			$("body").addClass("stop-scrolling-page");
				e.preventDefault();
		});

		$('.gallery-quad__slider').slick({
			infinite: true,
			arrows: false,
			dots: true,
			slide: '.slide-gallery',
			fade: true,
			speed: 700
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
		$('.home_reason .nav-arrows').slick({
			dots:false,
			asNavFor: ".reason-block",
			autoplay:false,
			autoplaySpeed:4000,
			speed:500,
			fade:true,
			accessibility:false,
			pauseOnHover:false,
			slidesToShow:1, 
			adaptativeHeight:true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
					  dots: true,
					  arrows: false
					}
				  }
			
			  ]
		});

		$('.benefits .benefits-block').slick({
			dots: false,
			arrow:true,
			slidesToShow: 3,
			slidesToScroll: 3,
			accessibility:false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
					  dots: true,
					  arrows: false
					}
				  },
				{
				  breakpoint: 768,
				  settings: {
					dots: true,
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					dots: false,
					slidesToShow: 1
				  }
				}
			  ]
		});

			// 	main menu
			var burger = $('#header .burger').on('click',function(){
			
				$(this).parent().toggleClass('open');
				
				
					if($('#header .main-menu').hasClass('open')){	
						var button_burger = burger.find('span').text();
								burger.find('span').text("CLOSE");
						
						if($('body#home').length > 0){
								$('.box-primary-nav-adventure').css({
								'top': heightHeader,
								'height': heightHeaderImageHome
							});
							if($("#booking-container").hasClass('open')){
								
								$("#booking-container").removeClass('open');
								var button_text = booking_btn.find('span').text();
								booking_btn.find('span').text(button_text == "Book Now" ? "X CLOSE" : "Book Now");
							}
						}else{
							$('.box-primary-nav-adventure').css({
								'top': heightHeader,
								'height': '630px'
							});
							if($("#booking-container").hasClass('open')){
								$("#booking-container").removeClass('open');
								var button_text = booking_btn.find('span').text();
								booking_btn.find('span').text(button_text == "Book Now" ? "X CLOSE" : "Book Now");
							}
						}
					}else{
					var button_burger = burger.find('span').text();
							burger.find('span').text("menu");
				
					$('.box-primary-nav-adventure').css({
						'top': heightHeader,
						'height': '0px'
					});
					}
				
				});



				$(this, 'html .our-hotel .expand-container').each(function(){
					$(this).find('.exp').append('<div class="details"><button>expand</button></div>');
					$(this).find('.details').click(showSpecialLanding);

				});

				function showSpecialLanding(){
					$(this).html('<button>collapse</button>');
					//$(this).parents().find('.full').css('height','auto');
					//$('.menu-landing').addClass('active');

					$(this).parent(1).find('.full').fadeIn(400, function(){
				//	$(this,'.our-hotel  .expand-container .full').fadeIn(400, function(){
					//		$('.our-hotel  .quad-container .excerpt').slideDown(500);

					});
					$(this).parents().eq(1).addClass('opened');
					$(this).unbind('click');
					$(this).click(hideSpecialLanding);
				}
				function hideSpecialLanding(){
					$(this).html('<button>expand</button>');
					//$(this).parent().find('.full').css('height','0px');
					$(this).parents().eq(1).removeClass('opened');
					//$('').slideUp(300);
					// $('.our-hotel  .quad-container .excerpt').slideUp(300);
					// $('.our-hotel  .quad-container .exp').fadeIn(400, function(){
						
					// });
					
					
					$(this).unbind('click');
					$(this).click(showSpecialLanding);
				}

				   //home map pins
				   $('.home-map .pins .pin').click(function(){
					var current = $(this).attr('data');
					$('.home-map .pins .pin').removeClass('active');
					$(this).addClass('active');
					$('.home-map .info ul li').removeClass('active');
					$('.home-map .info ul li[data='+current+']').addClass('active');
				});
		
				
				//hover states
				$('.home-map .pins .pin').mouseenter(function(){
					var current = $(this).attr('data');
					$(this).parent(1).find('.info-map[data='+current+']').slideDown("slow");
					$('.home-map .pins .pin').removeClass('active');
					$(this).parent(1).find('.info-map[data='+current+']').animate({opacity:1},300)
				
					$(this).parent(1).find('.info-map[data='+current+']').slideDown("slow");
					$(this).addClass('active');
					$('.home-map .info ul li').removeClass('active');
					$('.home-map .info ul li[data='+current+']').slideDown("slow");
				});
				$('.home-map .pins .pin').mouseout(function(){
					var current = $(this).attr('data');
					$(this).parent(1).find('.info-map[data='+current+']').animate({opacity:0},1000)
				
					
				});

				$('.home-map .info-map').hover(function(){
					$(this).parent(1).find('.info-map[data='+current+']').animate({opacity:1},300)
					
				});
				$('.home-map .info-map').mouseout(function(){
					$(this).parent(1).find('.info-map[data='+current+']').animate({opacity:0},1000)
				
				});
				// $('.home-map .info ul li').mouseenter(function(){
				// 	var current = $(this).attr('data');
				// 	$(this).parent(1).find('.info-map[data='+current+']').css('display','none');
				// 	$('.home-map .pins .pin').removeClass('active');
				// 	$('.home-map .info ul li').removeClass('active');
				// 	$(this).addClass('active');
				// 	$(this).parent(1).find('.info-map[data='+current+']').css('display','block');
					
				// 	$('.home-map .pins .pin[data='+current+']').addClass('active');
				// });
				

		
	
				
				
				



				
	});





}());

